import { render, staticRenderFns } from "./RadioWarning.vue?vue&type=template&id=467f9846&scoped=true&"
import script from "./RadioWarning.vue?vue&type=script&lang=js&"
export * from "./RadioWarning.vue?vue&type=script&lang=js&"
import style0 from "./RadioWarning.vue?vue&type=style&index=0&id=467f9846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f9846",
  null
  
)

export default component.exports